<template>
    <div>
        <input
        class="bg-gray-50 border border text-gray-900 text-sm rounded-lg focus:outline-none block w-full p-2.5"
        :class="error ? 'border-orange-400' : 'border-gray-300'"
        v-model="data"
        @keypress="isNumber($event)"
        :maxlength="4"
        id="date-fabrication"
        >
        <div class="my-1.5 text-xs font-light text-orange-400">{{error}}</div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        value: {}
    },
    watch: {
        data() {
            if (!this.data) {
                return 
            }

            if (this.data.length < 4) {
                this.error = this.$t('composants.sav-input-date-fabrication.le_code_doit_faire_4_chiffres')
            } else {
                this.error = null
            }

            const month = this.data.slice(0, 2)
            if (month > 12) {
                this.error = this.$t('composants.sav-input-date-fabrication.code_invalide')
            } else {
                this.error = null
            }

            if (this.data.length == 4) {
                const dateYear = this.data.slice(-2)
                const currentYear = moment().format('YYYY')
                let productYear = null
                if (currentYear.slice(-2) >= dateYear) {
                    productYear = currentYear.slice(0, 2) + dateYear
                } else {
                    productYear = (currentYear.slice(0, 2) - 1) + dateYear
                }
                if (productYear < currentYear - 50) {
                    this.error = this.$t('composants.sav-input-date-fabrication.produit_non_pris_en_charge')
                }

            }
            if (this.data.length == 4 && !this.error) {
                this.$emit('input', this.data)
            } else {
                this.$emit('input', null)
            }
        },
        value: function(value) {
            this.data = value
        }
    },
    data() {
        return {
            data: null,
            error: null,
        }
    },

    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            }
        }
    },

    mounted() {
        if (this.value) {
            this.data = this.value
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavInputDateFabrication.vue